import { ApplicationConfig, provideZoneChangeDetection, importProvidersFrom, LOCALE_ID, provideEnvironmentInitializer, inject } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideFirestore, getFirestore, Firestore } from '@angular/fire/firestore';
import { provideStorage, getStorage, Storage } from '@angular/fire/storage';
import { GooglePubSubService } from './core/services/pubsub/google-pubsub.service';
import { AgriFlowMessagingService } from './core/services/pubsub/agriflow-messaging.service';
import { NotificationService } from './core/services/notifications/notification.service';
import { provideAuth0 } from '@auth0/auth0-angular';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MaterialIconsService } from './core/services/material-icons.service';
import { provideLottieOptions } from 'ngx-lottie';
import player from 'lottie-web';
import { CSVBoxAngularModule } from '@csvbox/angular';

import { routes } from './app.routes';
import { environment } from '../environments/environment';

// Registra i dati di localizzazione italiana
registerLocaleData(localeIt);

export function playerFactory() {
  return player;
}

const loggerConfig: any = {
  level: environment.production ? NgxLoggerLevel.ERROR : NgxLoggerLevel.DEBUG,
  serverLogLevel: NgxLoggerLevel.ERROR
};

if (environment.production) {
  loggerConfig.serverLoggingUrl = `${environment.apiUrl}logs`;
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideAnimations(),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    // Pre-inizializza Firebase dentro il contesto di iniezione per evitare warning AngularFire
    provideEnvironmentInitializer(() => {
      // L'accesso tramite inject() garantisce il contesto di iniezione
      inject(Firestore);
      inject(Storage);
    }),
    GooglePubSubService,
    AgriFlowMessagingService,
    NotificationService,
    provideAuth0({
      domain: environment.auth0.domain,
      clientId: environment.auth0.clientId,
      authorizationParams: {
        redirect_uri: window.location.origin,
        audience: environment.auth0.audience
      }
    }),
    provideLottieOptions({
      player: playerFactory
    }),
    { provide: LOCALE_ID, useValue: 'it-IT' },
    ConfirmationService,
    MessageService,
    MaterialIconsService,
    importProvidersFrom([
      LoggerModule.forRoot(loggerConfig),
      CSVBoxAngularModule
    ])
  ]
};
